import { selectSingleProjectId } from '~/modules/project/project.selectors';
import { useAppSelector } from '~/modules/store';

import { testsApi } from '../../tests.api';

interface UseTestListArgs {
  query?: string;
  sortBy?: string;
  descOrder?: boolean;
}

export const useTestsList = ({ query, sortBy, descOrder }: UseTestListArgs | undefined = {}) => {
  const projectId = useAppSelector(selectSingleProjectId);
  const testsQuery = testsApi.useGetTestsQuery({
    query,
    ordering: descOrder ? `-${sortBy}` : sortBy,
    projectId,
  });

  return testsQuery;
};
